/** @file Sets one key of one channel (bone transform values absolute or, with relative, setup-relative). */
import { defineKeyCommand } from '../_shared/defineKeyCommand';

export const command = defineKeyCommand({
  description:
    'Set a key: channel rotation|x|y|scaleX|scaleY|shearX|shearY (absolute bone values, stored relative to setup; relative:true sends the stored value itself: added to setup, scale multiplied), inherit, attachment (placeholder or null), rgb|dark (#rrggbb), alpha, ikMix|ikSoftness|ikBend|ikStretch|ikCompress; curve on numeric channels only; unwrap:"shortest" for rotation.',
});
